import { RSAA } from 'redux-api-middleware';
import { selectors } from 'app-webtech-core/selectors';
import { LOADED, LOADING, LOADING_ERROR } from './types';
import { podTrackerAdsSetAdDataThunkAction } from '../../podTracker/ads/actions/setAdsData';
import { podTrackerAdsRequestAdsDataAction } from '../../podTracker/ads/actions/requestAdsData';

const fetchPlaybackSession = ({ sessionUrl }) => ({
  [RSAA]: {
    endpoint: `${sessionUrl}?clientTime=${Math.round(Date.now() / 1000)}`,
    method: 'GET',
    credentials: 'same-origin',
    authorization: false,
    types: [
      {
        type: LOADING,
        meta: { params: { sessionUrl } },
      },
      {
        type: LOADED,
        payload: (action, state, res) => res.json(),
        meta: { params: { sessionUrl } },
      },
      {
        type: LOADING_ERROR,
        meta: { params: { sessionUrl } },
      },
    ],
  },
});

// eslint-disable-next-line no-unused-vars
export const playbackSessionLoadApiAction = () => async (dispatch, getState) => {
  const state = getState();
  dispatch(podTrackerAdsRequestAdsDataAction());
  const { stitcher } = selectors.application.servers(state);
  const { ID } = selectors.playbackSession.properties(state);
  const sessionUrl = `${stitcher}/session/${ID}.json`;
  const { payload } = await dispatch(fetchPlaybackSession({ sessionUrl }));
  dispatch(podTrackerAdsSetAdDataThunkAction(payload));
};
